export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://127.0.0.1:5155';

export const ROUTES = {
  LOGIN: '/login',
  AUTH_CALLBACK: '/auth/callback',
  CONTROL: '/control',
  ENTER: '/enter',
  ROOM_PATTERN: '/room/:roomId',
  ROOM: (id) => `/room/${id}`,
  ACCOUNT_CONFIG_PATTERN: '/account/:spotifyUserId/config',
  ACCOUNT_CONFIG: (id) => `/account/${id}/config`,
  GRACIAS: '/gracias',
  COOLDOWN: '/cooldown',
};

export const WHATSAPP_NUMBER = '51955786754';
export const whatsappPlanUrl = (planLabel) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    `Hola, quiero el plan ${planLabel} de RockCola`
  )}`;

export const API = {
  AUTH: {
    LOGIN: `${API_BASE_URL}/auth/login`,
    CALLBACK: `${API_BASE_URL}/auth/callback`,
  },
  ME: {
    subscription: `${API_BASE_URL}/me/subscription`,
  },
  ROOMS: {
    BASE: `${API_BASE_URL}/rooms`,
    SCAN: `${API_BASE_URL}/rooms/scan`,
  },
  SPOTIFY: {
    search: (roomId) => `${API_BASE_URL}/rooms/${roomId}/search`,
    catalog: (roomId) => `${API_BASE_URL}/rooms/${roomId}/catalog`,
    queue: (roomId) => `${API_BASE_URL}/rooms/${roomId}/queue`,
    status: (roomId) => `${API_BASE_URL}/rooms/${roomId}/status`,
    sent: (roomId) => `${API_BASE_URL}/rooms/${roomId}/sent`,
  },
  ACCOUNT: {
    config: (id) => `${API_BASE_URL}/auth/spotify/${id}/config`,
    staticQr: (id) => `${API_BASE_URL}/auth/spotify/${id}/static-qr`,
  },
  QR_SCAN_BASE_URL: `${window.location.origin}/enter`,
};
